/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'element-resource-list': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M42 36H5v4h37v-4zM5 33a3 3 0 0 0-3 3v4a3 3 0 0 0 3 3h37a3 3 0 0 0 3-3v-4a3 3 0 0 0-3-3H5z"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M5 40v-4h37v4H5zm-3-4a3 3 0 0 1 3-3h37a3 3 0 0 1 3 3v4a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-4z"/><path pid="2" fill-rule="evenodd" clip-rule="evenodd" d="M5 40v-4h37v4H5zm-3-4a3 3 0 0 1 3-3h37a3 3 0 0 1 3 3v4a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-4zm40-14H5v4h37v-4zM5 19a3 3 0 0 0-3 3v4a3 3 0 0 0 3 3h37a3 3 0 0 0 3-3v-4a3 3 0 0 0-3-3H5zM42 8H5v4h37V8zM5 5a3 3 0 0 0-3 3v4a3 3 0 0 0 3 3h37a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3H5z"/><path pid="3" fill-rule="evenodd" clip-rule="evenodd" d="M35 13V7h3v6h-3zm0 14v-6h3v6h-3zm0 14v-6h3v6h-3z"/>'
  }
})
